<header class="">
  <nav class="navbar navbar-expand-lg navbar-light fixed-top py-1" id="navbar">
    <div class="container">
      <a class="navbar-brand order-lg-1" routerLink="/">
        <img
          src="assets/img/efb_primary.svg"
          loading="lazy"
          width="80"
          class="img-fluid"
          alt="logo"
          id="logo"
        />
      </a>
      <div class="d-flex align-items-center gap-2 order-lg-3">
        <a
          *ngIf="!stateChange && PNS_AUTH_MODE === true"
          [href]="LINK_URL"
          class="btn btn-success text-nowrap shadow-lg"
          type="button"
        >
          <i class="bi-people me-2"></i>
          {{ "CITOYEN" | translate }}
        </a>

        <a
          *ngIf="!stateChange && PNS_AUTH_MODE === false"
          (click)="authentication()"
          class="btn btn-success text-nowrap shadow-lg"
          type="button"
        >
          <i class="bi-people me-2"></i>
          {{ "CITOYEN" | translate }}
        </a>

        <div class="dropdown py-2" *ngIf="stateChange">
          <a
            class="nav-link dropdown-toggle style_font_size_small style_medium d-flex align-items-center style_after_none"
            role="button"
            data-bs-toggle="dropdown"
            aria-expanded="false"
          >
            <div
              class="style_bg_img rounded-circle text-white"
              style="background-color: #db0000; width: 35px; height: 35px"
            >
              <div
                class="d-flex justify-content-center align-items-center rounded-circle p-2 w-100 h-100"
                style="background-color: rgba(0, 0, 0, 0)"
              >
                <span class="mb-0">{{ name ?? "" | initials }} </span>
              </div>
            </div>
          </a>
          <ul
            class="dropdown-menu dropdown-menu-end p-3 border-0 shadow"
            style="
              min-width: 18rem;
              max-height: 30rem;
              overflow-y: auto;
              -ms-overflow-style: none;
              overflow: -moz-scrollbars-none;
            "
          >
            <a class="">
              <h6 class="mb-0 style_bold">{{ name }}</h6>
              <small>{{ npi }}</small>
            </a>

            <hr />
            <div class="list-group p-0">
              <a
                routerLink="/portail-citoyen/citizens-liste-parcel"
                class="rounded-2 list-group-item list-group-item-action border-0 d-flex justify-content-between align-items-center"
              >
                <span>
                  <i class="bi-window me-2"></i>
                  {{ "CHART_BTN" | translate }}
                </span>
              </a>
              <a
                data-bs-toggle="modal"
                style="cursor: pointer"
                data-bs-target="#exampleModalDeconnexion"
                class="rounded-2 list-group-item list-group-item-action border-0 d-flex justify-content-between align-items-center"
              >
                <span
                  ><i class="bi-power me-2"></i>
                  {{ "LOGOUT_BTN" | translate }}
                </span>
              </a>
            </div>
          </ul>
        </div>

        <button
          class="navbar-toggle border-0 d-lg-none border-0 bg-transparent"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#navbarSupportedContent"
          aria-controls="navbarSupportedContent"
          aria-expanded="false"
          aria-label="Toggle navigation"
        >
          <span class="navbar-toggler-icon"></span>
        </button>
      </div>
      <div
        class="collapse navbar-collapse flex-grow-0 order-lg-2 w-100"
        id="navbarSupportedContent"
      >
        <ul class="navbar-nav mx-auto">
          <li class="nav-item">
            <a
              [routerLink]="['/']"
              class="nav-link me-3"
              routerLinkActive="active"
              [routerLinkActiveOptions]="{ exact: true }"
              ><i class="bi-house me-2"></i>
              {{ "ACCUEIL" | translate }}
            </a>
          </li>
          <li class="nav-item">
            <a href="https://test-cadastre.andf.bj/accueil" target="_blank" class="nav-link me-3">
              <i class="bi-map me-2"></i>
              {{ "CADASTRE" | translate }}
            </a>
          </li>
          <li class="nav-item">
            <a
              routerLink="/publications"
              class="nav-link me-3"
              routerLinkActive="active"
              [routerLinkActiveOptions]="{ exact: true }"
              ><i class="bi-stickies me-2"></i>Publications</a
            >
          </li>
          <li class="nav-item dropdown">
            <a
              class="nav-link dropdown-toggle d-flex align-items-center gap-1"
              role="button"
              data-bs-toggle="dropdown"
              aria-expanded="false"
            >
              <i class="bi-flag"></i>
              <span>{{ "LANGUAGE" | translate }}</span>
            </a>
            <ul class="dropdown-menu py-0">
              <li style="cursor: pointer" [class.active]="selectedLanguage === 'fr'">
                <a
                  class="dropdown-item d-flex align-items-center gap-1"
                  [class.active]="selectedLanguage === 'fr'"
                  (click)="switchLanguage('fr')"
                >
                  <span>{{ "FRANÇAIS" | translate }}</span>
                </a>
              </li>
              <li style="cursor: pointer" [class.active]="selectedLanguage === 'en'">
                <a
                  class="dropdown-item d-flex align-items-center gap-1"
                  [class.active]="selectedLanguage === 'en'"
                  (click)="switchLanguage('en')"
                >
                  <span>{{ "ANGLAIS" | translate }}</span>
                </a>
              </li>
            </ul>
          </li>
        </ul>

        
      </div>
    </div>
  </nav>
</header>

<!-- Modal -->
<div
  #deconnexionModal
  class="modal fade"
  id="exampleModalDeconnexion"
  data-bs-backdrop="static"
  tabindex="-1"
  aria-labelledby="exampleModalInitialisationLabel"
  aria-hidden="true"
  style="
    background: linear-gradient(
      90deg,
      rgba(226, 244, 242, 0.6) -2.71%,
      rgba(248, 248, 239, 0.6) 58.43%,
      rgba(249, 237, 238, 0.6) 100%
    );
  "
>
  <div class="modal-dialog modal-dialog-centered" style="cursor: pointer">
    <div class="modal-content border-0">
      <div class="modal-header border-0 pb-0 align-items-start">
        <h5 class="mb-0" id="exampleModalInitialisationLabel">
          Vous êtes sur le point de vous déconnecter
        </h5>
        <button
          type="button"
          class="btn-close ms-md-5"
          (click)="closedModalForDeconnexion()"
          aria-label="Close"
        ></button>
      </div>
      <div class="modal-body" (click)="logOut()">
        <div
          class="h-100 py-4 style_gradient text-center p-3 rounded-3 d-flex flex-column align-items-center text-success"
        >
          <h1 class="mb-1 display-3"><i class="bi-door-open"></i></h1>
        </div>
      </div>
      <div class="modal-footer border-0 pt-0">
        <button type="button" class="btn btn-secondary" (click)="closedModalForDeconnexion()">
          <i class="bi-x me-1"></i>Non
        </button>
        <button (click)="logOut()" type="button" class="btn btn-success shadow-sm">
          <i class="bi-check me-1"></i>Oui
        </button>
      </div>
    </div>
  </div>
</div>

<!-- Modal -->
<div
  #emailAuthModal
  class="modal fade"
  id="exampleModalEmailAuth"
  data-bs-backdrop="static"
  tabindex="-1"
  aria-labelledby="exampleModalEmailAuthLabel"
  aria-hidden="true"
  style="
    background: linear-gradient(
      90deg,
      rgba(226, 244, 242, 0.6) -2.71%,
      rgba(248, 248, 239, 0.6) 58.43%,
      rgba(249, 237, 238, 0.6) 100%
    );
  "
>
  <div class="modal-dialog modal-dialog-centered" style="cursor: pointer">
    <div class="modal-content border-0">
      <form action="" method="post">
        <div class="modal-header border-0 pb-0 align-items-start">
          <h5 class="mb-0" id="exampleModalEmailAuthLabel">Connexion</h5>
          <button
            type="button"
            class="btn-close ms-md-5"
            (click)="closedModalForAuthentication()"
            aria-label="Close"
          ></button>
        </div>
        <div class="modal-body">
          <div class="mb-3">
            <label class="mb-1"
              >Numéro Personnel d'Identification <span class="text-danger">*</span></label
            >
            <input
              class="form-control"
              type="text"
              placeholder="Numéro personnel d'identification"
            />
          </div>
        </div>
        <div class="modal-footer border-0 pt-0">
          <button type="button" class="btn btn-secondary" (click)="closedModalForAuthentication()">
            <i class="bi-x me-1"></i>
            Annuler
          </button>
          <button type="button" class="btn btn-success shadow-sm">
            <i class="bi-check me-1"></i>
            Valider
          </button>
        </div>
      </form>
    </div>
  </div>
</div>
